import {
  forwardRef,
  memo,
  useEffect,
  useRef,
} from "react";
import { useTranslation } from "react-i18next";

import { Sender } from "@ant-design/x";
import { GetRef } from "antd";

import { default as classes } from "./_.module.scss";
import { ChatSenderProps } from "./_type";

import { usePopupContext } from "~/common/contexts/knowledge";

/**
 * ChatSender Component View
 */
export default memo(
  forwardRef<boolean, ChatSenderProps>(({ disabled = false }) => {
    const { states, events } = usePopupContext();
    const { content, isRequesting } = states;
    const { onSubmit, setContent, handleCancel } = events;
    const senderRef = useRef<GetRef<typeof Sender>>(null);

    const { t } = useTranslation("common");

    /** Auto focus */
    useEffect(() => {
      if (senderRef.current?.focus) {
        setTimeout(() => {
          senderRef.current?.focus();
        }, 100);
      }
    }, []);

    /** render */
    return (
      <div className="flex flex-col gap-3">
        <div className={classes.senderContainer}>
          <Sender
            ref={senderRef}
            value={content}
            loading={isRequesting}
            placeholder={
              disabled
                ? t("chat.sender.unavailable")
                : t("chat.sender.placeholder")
            }
            onChange={disabled ? () => {} : setContent}
            onCancel={handleCancel}
            onSubmit={disabled ? () => {} : onSubmit}
            onFocus={() => {}}
            onBlur={() => {}}
            onKeyUp={() => {}}
            disabled={disabled ? true : undefined}
          />
        </div>
      </div>
    );
  }),
);
